import { StashEnvironment } from 'stash/types/StashEnvironment';

export const SEGMENT_WRITE_KEYS: Record<StashEnvironment, string> = {
	production: 'y1IRbCVDdBnvyJ5OH0DShNFjMh6Kj9jO',

	// There is a single segment environment for non-production environments
	__STASH_ENV__: 'P8edwp1dspS4jRZDNNJsjYk2Z7zR3jlS',
	edge: 'P8edwp1dspS4jRZDNNJsjYk2Z7zR3jlS',
	staging: 'P8edwp1dspS4jRZDNNJsjYk2Z7zR3jlS',
};

export const SEGMENT_CDN_PROXY_URL = 'https://analytics.stash.com/load';
